export const SKIP_BASIC_AUTH_HEADER = 'skip-basic-auth-header=true';
